'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SanitizeHtml = require('./SanitizeHtml');

var _SanitizeHtml2 = _interopRequireDefault(_SanitizeHtml);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Truncate = function (_React$Component) {
  (0, _inherits3.default)(Truncate, _React$Component);

  function Truncate(props) {
    (0, _classCallCheck3.default)(this, Truncate);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Truncate.__proto__ || (0, _getPrototypeOf2.default)(Truncate)).call(this, props));

    _this.state = {
      showAll: false
    };

    _this.toggle = _this.toggle.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Truncate, [{
    key: 'getString',
    value: function getString() {
      var _props = this.props,
          value = _props.value,
          words = _props.words,
          characters = _props.characters,
          ellipse = _props.ellipse;
      var showAll = this.state.showAll;


      if (showAll) {
        return {
          string: value,
          ellipsed: false
        };
      }

      var splitOn = characters ? '' : ' ';
      var result = (value || '').split(splitOn).slice(0, characters || words).join(splitOn);
      var ellipsed = result.length < value.length;
      return {
        string: '' + result + (ellipsed ? ellipse : ''),
        ellipsed: ellipsed
      };
    }
  }, {
    key: 'toggle',
    value: function toggle(e) {
      e.preventDefault();

      this.setState({
        showAll: !this.state.showAll
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          value = _props2.value,
          button = _props2.button,
          nl2br = _props2.nl2br;


      if (!value) {
        return null;
      }

      var _getString = this.getString(),
          string = _getString.string,
          ellipsed = _getString.ellipsed;

      return _react2.default.createElement(
        'p',
        null,
        !nl2br && string,
        nl2br && _react2.default.createElement('span', { dangerouslySetInnerHTML: (0, _SanitizeHtml2.default)(string.split('\n').join('<br />')) }),
        ' ',
        ellipsed && _react2.default.createElement(
          'span',
          { role: 'button', tabIndex: '0', className: 'btn btn-link', onClick: this.toggle },
          button
        )
      );
    }
  }]);
  return Truncate;
}(_react2.default.Component);

Truncate.propTypes = {
  value: _propTypes2.default.string,
  words: _propTypes2.default.number,
  characters: _propTypes2.default.number,
  ellipse: _propTypes2.default.string,
  button: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.shape({
    children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.string]).isRequired,
    route: _propTypes2.default.string,
    path: _propTypes2.default.string
  })]),
  nl2br: _propTypes2.default.bool
};
Truncate.defaultProps = {
  value: undefined,
  children: null,
  words: 50,
  characters: undefined,
  button: 'Read More',
  ellipse: '...',
  nl2br: false
};

exports.default = Truncate;


//////////////////
// WEBPACK FOOTER
// ./~/@bd/bdcore-utilities/build/Truncate.js
// module id = 787
// module chunks = 0